import React, { useEffect } from 'react';
import { formatPrice } from '../utils'; // Import the formatPrice helper

const RentalValuation = ({ valuation }) => {
  let averageWeeklyPrice = null;
  let lowerBound = null;
  let upperBound = null;

  if (valuation && valuation.data && valuation.data.long_let) {
    // Extract the necessary data
    averageWeeklyPrice = valuation.data.long_let.average;
    [lowerBound, upperBound] = valuation.data.long_let['70pc_range'];
  }

  // Log the extracted values to the console
  useEffect(() => {
    if (averageWeeklyPrice !== null && lowerBound !== null && upperBound !== null) {
      console.log("Average Weekly Price:", averageWeeklyPrice);
      console.log("70% Range Weekly Price:", { lowerBound, upperBound });
    }
  }, [averageWeeklyPrice, lowerBound, upperBound]);

  if (!valuation || !valuation.data || !valuation.data.long_let) {
    return <p>No rental valuation data available.</p>;
  }

  // Convert weekly prices to monthly prices and round to the nearest £10
  const roundToNearestTen = (price) => Math.ceil(price / 10) * 10;

  const averageMonthlyPrice = roundToNearestTen(averageWeeklyPrice * 4.333);
  const lowerBoundMonthly = roundToNearestTen(lowerBound * 4.333);
  const upperBoundMonthly = roundToNearestTen(upperBound * 4.333);

  return (
    <div className="rental-valuation-container">
        <p className="valuation-price">
        £{formatPrice(averageMonthlyPrice)}<span className="pcm">pcm</span>
        </p>

      <p className="valuation-bounds">
        Estimated bounds: £{formatPrice(lowerBoundMonthly)} - £{formatPrice(upperBoundMonthly)} pcm
      </p>
    </div>
  );
};

export default RentalValuation;
